import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { type IPost } from 'types/interfaces/ITypes'

type PurchasesCacheEntry = {
  posts: IPost[]
  updatedAt: number
}

type PurchasesCacheStore = {
  cache: Record<string, PurchasesCacheEntry>

  getPosts: (key: string) => IPost[]
  getUpdatedAt: (key: string) => number | null

  setPosts: (key: string, posts: IPost[]) => void

  clearPosts: (key: string) => void
  clearAll: () => void
}

export const usePurchasesCacheStore = create<PurchasesCacheStore>()(
  persist(
    (set, get) => ({
      cache: {},

      getPosts: key => {
        return get().cache[key]?.posts ?? []
      },

      getUpdatedAt: key => {
        return get().cache[key]?.updatedAt ?? null
      },

      setPosts: (key, posts) => {
        set(state => ({
          cache: {
            ...state.cache,
            [key]: {
              posts,
              updatedAt: Date.now()
            }
          }
        }))
      },

      clearPosts: key => {
        set(state => {
          const nextCache = { ...state.cache }

          // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
          delete nextCache[key]

          return {
            cache: nextCache
          }
        })
      },

      clearAll: () => {
        set({
          cache: {}
        })
      }
    }),
    {
      name: 'purchases-feed-cache'
    }
  )
)